import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';

/**
 * 鉴权守卫 — 没 token 时跳到 /login,登录后跳回原地。
 */
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const token = useAuthStore((s) => s.token);
  const location = useLocation();
  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
